<script setup>
import SiteInfo from "../components/SiteInfo.vue";
import { useEvent, useHttp } from "vutil";
import { ref } from "vue";

const { data, error, get } = useHttp();
const site = ref(null);
const pos = ref(null);
let bounds;

function getSites()
{
	get(`/api/site/geo/area?min_lng=${bounds.getWest()}&min_lat=${bounds.getSouth()}&max_lng=${bounds.getEast()}&max_lat=${bounds.getNorth()}`);
	console.log("get", bounds && bounds.toString());
}

function move(map)
{
	bounds = map.getBounds();
	getSites();
}

useEvent(document, "visibilitychange", () => !document.hidden && bounds && getSites());

navigator.geolocation.getCurrentPosition(({ coords }) => {
	pos.value = [coords.longitude, coords.latitude];
}, (err) => {
	error.value = err.message;
});
</script>

<template>
	<div v-if="error" class="error">{{ error }}</div>
	<VmapMap v-else-if="pos" :center="pos" :zoom="13" :_min-zoom="12" @load="move" @moveend="move">
		<VmapMarker v-for="s in data" :key="s.id" :lat="s.lat" :lng="s.lng" @click="site = s">
			<img :class="s.available ? 'icon-charging-station-free' : 'icon-charging-station-busy'"/>
		</VmapMarker>
	</VmapMap>
	<SiteInfo v-if="site" :pos="pos" :site="site" @close="site = null"/>
</template>
